import { defineComponent as _defineComponent } from 'vue'
import {useTranslations} from "@/hooks/useTranslations";
import SignupDto from "@/models/Restaurants/SignupDto";
import {getCurrentInstance, onMounted, ref} from "vue";
import {useNotify} from "@/hooks/useNotify";
import CustomersRepository from "@/utils/API/CustomersRepository";
import {MarketingParams} from "@/models/Subscriptions/MarketingParams";
import Industry from "@/models/Industry";
import Country from "@/models/Country";
import GeneralRepository from "@/utils/API/GeneralRepository";

type DirectSignupFormProps = {
  marketingParams: MarketingParams;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DirectSignupForm',
  props: {
    marketingParams: null
  },
  emits: ["signupSuccess"],
  setup(__props: any, { emit }) {

const props = __props as {
  marketingParams: MarketingParams;
};





const translations = useTranslations();
const { proxy } = getCurrentInstance();
const validator = proxy.$validator;
const notify = useNotify();

const signupFormData = ref<Omit<SignupDto, "marketingParams" | "shouldSkipFreeTrial" | "countryId" | "industryId">>({
  name: "",
  phone: "",
  ownerFirstName: "",
  ownerLastName: "",
  ownerEmail: "",
  ownerPassword: "",
  confirmOwnerPassword: "",
  referrer: "",
  hasRequestedNewsLetter: false,
});
const phoneTouched = ref(false);
const invalidPhone = ref(false);
const agreeTerms = ref(false);
const passwordMinLength = ref(8);
const countryList = ref<Country[]>([]);
const industryList = ref<Industry[]>([]);

const selectedIndustry = ref<Industry>();
const selectedCountry = ref<Country>();

onMounted(async() => {
  countryList.value = (await GeneralRepository.listCountries()).data.result;
  industryList.value = (await GeneralRepository.listIndustries()).data.result;
});

async function createAccount() {
  phoneTouched.value = true;

  const result = await validator.validateAll("accCreate");

  if (result && !invalidPhone.value) {
    if (!agreeTerms.value) {
      notify.error(translations.value.get("login_accept_terms_message"));
      return;
    }

    notify.info(translations.value.get("login_creating"));

    try {
      await signup();
      notify.success(translations.value.get("verification_code_sent"));
      emit("signupSuccess", signupFormData.value.ownerEmail);
    }

    catch (error: any) {
      const message = error.response
        ? error.response.data.errorMessages[0].userVisibleMessage
        : translations.value.get("network_error");

      notify.error(message);
    }

    return;
  }

  notify.error(translations.value.get("validation-error-message"));
}

async function signup() {
  await CustomersRepository.signup({
    shouldSkipFreeTrial: true,
    countryId: selectedCountry.value.id,
    industryId: selectedIndustry.value.id,
    marketingParams: props.marketingParams,
    ...signupFormData.value,
  });
}

function handlePhoneValidation(response: any){
  invalidPhone.value = !response.isValid;
}

return { __sfc: true,props, emit, translations, proxy, validator, notify, signupFormData, phoneTouched, invalidPhone, agreeTerms, passwordMinLength, countryList, industryList, selectedIndustry, selectedCountry, createAccount, signup, handlePhoneValidation }
}

})